import React from 'react';
import './TypingHeader.css';

const TypingHeader = ({ text }) => {
  return (
    <div className="typewriter">
      <h3>{text}</h3>
    </div>
  );
};

export default TypingHeader;
